import { render, staticRenderFns } from "./VideoListDetail.vue?vue&type=template&id=4478dbeb"
import script from "./VideoListDetail.vue?vue&type=script&lang=js"
export * from "./VideoListDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoListDetail.vue?vue&type=style&index=0&id=4478dbeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports